var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('span',{staticClass:"title-img"},[_vm._v("Image ")])]),_c('b-col',{attrs:{"md":"12"}},[_c('ImageUpload',{staticClass:"mt-1",attrs:{"v":_vm.v.image_url,"dataFile":_vm.text.image_url},on:{"handleChangeImage":_vm.handleChangeImage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }